
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VaLightboxConfig } from './lightbox.interface';

/**
 * @deprecated Use {@link VaFullscreenLightboxService} instead.
 */
@Component({
  selector: 'va-lightbox',
  templateUrl: 'lightbox.component.html',
  styleUrls: ['lightbox.component.scss'],
  imports: [MatIconModule, MatButtonModule],
})
export class VaLightboxComponent {
  @Input() useSrcSet = true;
  currentIndex: number;
  lightboxConfig: VaLightboxConfig;

  isVisible: boolean;

  @Output() closed: EventEmitter<void> = new EventEmitter<void>();

  open(config: VaLightboxConfig): void {
    this.lightboxConfig = config;
    this.currentIndex = config.index;
    this.isVisible = true;
  }

  getSrcSetForImage(image: string): string | null {
    if (!image) {
      return null;
    }
    return `${image}=s1360 1360w, ${image}=s680 680w`;
  }

  close(): void {
    this.isVisible = false;
    this.closed.emit();
  }

  previousImage(): void {
    const isFirstImage = this.currentIndex === 0;
    if (isFirstImage) {
      this.currentIndex = this.lightboxConfig.imageUrls.length - 1;
    } else {
      this.currentIndex--;
    }
  }

  nextImage(): void {
    const isLastImage = this.currentIndex === this.lightboxConfig.imageUrls.length - 1;
    if (isLastImage) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
  }
}
